export const PERMISSIONS = {
  PENGUMUMAN: 'Pengumuman',
  SHIFT: 'Shift',
  JAM_KERJA: 'Jam Kerja',
  DIVISI: 'Divisi',
  JABATAN: 'Jabatan',
  LOKASI_KUNJUNGAN: 'Lokasi Kunjungan',
  LOKASI_KERJA: 'Lokasi Kerja',
  DAFTAR_ISTILLAH: 'Daftar Istillah',
  INVENTARIS: 'Inventaris',
  PENGAJUAN_IZIN: 'Pengajuan Izin',
  PENGAJUAN_LEMBUR: 'Pengajuan Lembur',
  PENGAJUAN_KASBON: 'Pengajuan Kasbon',
  PENGAJUAN_KLAIM_BEBAN: 'Pengajuan Klaim Beban',
  PENGAJUAN_INVENTARIS: 'Pengajuan Inventaris',
  PENGAJUAN_REVISI_DATA: 'Pengajuan Revisi Data',
  DAFTAR_KARYAWAN: 'Daftar Karyawan',
  DAFTAR_GAJI_KARYAWAN: 'Daftar Gaji Karyawan',
  LAPORAN_CUTI: 'Laporan Cuti',
  KEUANGAN: 'Keuangan',
  PRESENSI: 'Presensi',
  AGENDA: 'Agenda',
  KUNJUNGAN: 'Kunjungan',
  TUGAS: 'Tugas',
  DAFTAR_PAYROLL: 'Daftar Payroll',
  PENGATURAN_PAYROLL: 'Pengaturan Payroll',
  DAFTAR_ISTILAH: 'Daftar Istilah',
  PEMBAYARAN_KASBON: 'Pembayaran Kasbon',
  LANGGANAN: 'Langganan',
  PENGATURAN: 'Pengaturan',
  PEMANTAUAN: 'Pemantauan',
};

export const hasPageAccess = (userLevel, requiredPermission) => {
  if (!userLevel || userLevel.level_page_limited === null) {
    return true;
  }

  const permissionsArray = userLevel.level_page_limited
    .split(',')
    .map(p => p.trim());
  
  return permissionsArray.includes(requiredPermission);
};

export const getAllPermissions = () => Object.values(PERMISSIONS);
